import dropzone from 'react-dropzone'
import React, { Component } from 'react'
import Button from '../../../components/Button'
import { Field } from 'redux-form'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import s from './NumbersTwilioUploadDocumentsStep.scss'
import { Table, TableRow } from '../../Table'
import Radio from '../../../components/Input/Radio'

const Dropzone = dropzone.default

export default class NumbersTwilioUploadDocumentsStep extends Component {
  uploadFiles = filesToUpload => {
    const { name, uploadTwilioDocument, change } = this.props

    Promise.allSettled(
      filesToUpload.map(file =>
        uploadTwilioDocument({ file, id: name }).then(data => {
          return {
            file: file,
            hash: data.action.payload.data.hash,
          }
        })
      )
    ).then(results => {
      const {
        formData: { uploadedFiles },
      } = this.props

      change(
        'uploadedFiles',
        [].concat(
          uploadedFiles,
          results.filter(result => result.status === 'fulfilled').map(result => result.value)
        )
      )
    })
  }

  deleteFile = hash => {
    const {
      formData: { uploadedFiles },
      change,
    } = this.props

    change(
      'uploadedFiles',
      uploadedFiles.filter(file => {
        return file.hash !== hash
      })
    )
  }

  render() {
    const {
      prev,
      loading,
      name,
      change,
      submit,
      formData: { endUserType, uploadedFiles },
    } = this.props

    const hasUploadedFiles = uploadedFiles.length > 0
    const endUserTypeName = 'endUserType'

    return (
      <div>
        <div className={s.endUserType}>
          <div className={cn(sText.descrip1, sText.center, s.header)}>
            End-User of the Phone Number
          </div>
          <Field
            className={s.radio}
            name={endUserTypeName}
            radioValue="individual"
            component={Radio}
            label="Individual"
            afterChange={value => change(endUserTypeName, value)}
          />
          <p>An individual will make or receive calls with the phone number.</p>

          <Field
            className={s.radio}
            name={endUserTypeName}
            radioValue="business"
            component={Radio}
            label="Business"
            afterChange={value => change(endUserTypeName, value)}
          />
          <p>A business will make or receive calls with the phone number.</p>
        </div>

        {endUserType && (
          <div>
            <div className={cn(sText.descrip1, sText.center, s.header)}>
              Upload Supporting Documents
            </div>
            <div style={{ position: 'relative' }}>
              <Dropzone id={name} className={s.dropzone} onDrop={this.uploadFiles}>
                Click or Drag files here
              </Dropzone>
              {loading && <LoadingOverlay />}
            </div>
          </div>
        )}

        {hasUploadedFiles && (
          <Table>
            {uploadedFiles.map(file => (
              <TableRow key={file.hash}>
                <div>{file.file.name}</div>

                <div style={{ maxWidth: '85px' }}>
                  <Button color="warn" size="xs" ghost onClick={() => this.deleteFile(file.hash)}>
                    Delete
                  </Button>
                </div>
              </TableRow>
            ))}
          </Table>
        )}

        {endUserType === 'business' && (
          <div className={s.info}>
            <p className={s.subHeader}>Information required</p>
            <ul className={s.list}>
              <li>Business ID Number</li>
              <li>Business Name</li>
              <li>Business Address (Proof of Address)</li>
            </ul>

            <p className={s.subHeader}>Acceptable supporting documents</p>
            <ul className={s.list}>
              <li>ASIC company extracts</li>
              <li>Commercial registry and bank statement</li>
              <li>Commercial registry and proof of address</li>
            </ul>

            <p>
              For more information please visit our{' '}
              <Button
                plain
                target="_blank"
                href="https://helpcentre.thinkpickle.com.au/en/articles/3996826-virtual-mobile-number-regulations"
              >
                article
              </Button>
            </p>
          </div>
        )}

        {endUserType === 'individual' && (
          <div className={s.info}>
            <p className={s.subHeader}>Information required</p>
            <ul className={s.list}>
              <li>Proof of Identity</li>
              <li>Proof of Address</li>
            </ul>

            <p className={s.subHeader}>Acceptable supporting documents</p>
            <ul className={s.list}>
              <li>Valid Australian drivers licence/photo card</li>
            </ul>
            <p className={s.subHeader}>Or</p>
            <p>
              Two forms of ID
              <br />
              <br />
              Proof of identity (Current)
            </p>
            <ul className={s.list}>
              <li>Government-issued ID</li>
              <li>Passport</li>
            </ul>
            <p>Proof of Address (Within last 3 months)</p>
            <ul className={s.list}>
              <li>Utility Bill</li>
              <li>Tax Notice</li>
              <li>Rent Receipt</li>
              <li>Council Rates</li>
            </ul>
            <p>
              For more information please visit our{' '}
              <Button
                plain
                target="_blank"
                href="https://helpcentre.thinkpickle.com.au/en/articles/3996826-virtual-mobile-number-regulations"
              >
                article
              </Button>
            </p>
          </div>
        )}

        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button
            color="tertiary"
            type="submit"
            disabled={!hasUploadedFiles || !endUserType}
            onClick={() => {
              change('endUserType', 'individual')
              submit()
            }}
          >
            Next
          </Button>
          <br />
          <br />
          <Button plain onClick={prev}>
            Back
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersTwilioUploadDocumentsStep/NumbersTwilioUploadDocumentsStep.jsx